import React from "react";
import {ComboBoxItemType} from "../ComboBoxTypes";

const ComboBoxItem = (props: ComboBoxItemType) => {
    return (
        <div
            className={`item-menu-entry ${props.selectedValues && props.selectedValues === props.item.value ? 'active' : ''}`}
            onClick={(e) => props.onChangeCallback(e, props.item)}
            onKeyDown={(e: any) => props.onKeyDownCallback(e)}
            title={props.item.label}
            data-value={props.item.value}
            tabIndex={0}
        >
            {props.itemLabel ? props.itemLabel : props.item.label}
        </div>
    )
}

export default ComboBoxItem